// extracted by mini-css-extract-plugin
export default {"wrapper":"Page_wrapper__18eIW","header":"Page_header__IzLgX","goBack":"Page_goBack__7apdX","title":"Page_title__4PRV2","pageContent":"Page_pageContent__2pndO"};